import moment from 'moment';

const getPeriod = (value, unit) => [moment().subtract(value, unit), moment()];

export default getPeriod;
